<ul class="nav nav-tabs" role="tablist" style="margin-right: 15px; margin-top: 20px">
  <li role="presentation" class="active">
    <a href="#blockSpecifications" aria-controls="blockSpecifications" role="tab" data-toggle="tab">Model</a>
  </li>

  <li role="presentation">
    <a href="#constraints" aria-controls="constraints" role="tab" data-toggle="tab"> Constraints </a>
  </li>

  <li role="presentation">
    <a href="#fuelGasSinkImportComments" aria-controls="fuelGasSinkImportComments" role="tab" data-toggle="tab">
      <i class="fa fa-comments fa-lg {{ this.unitOperation.comments ? 'gentle-hover-shake' : '' }}" aria-hidden="true">
      </i>
      Comments
    </a>
  </li>
</ul>

<div class="tab-content pw-margin tab-content-padding" [formGroup]="propertyWindowFormGroup">
  <div role="tabpanel" class="tab-pane fade in active" id="blockSpecifications">
    <div class="tab-content no-padding no-border">
      <div class="form-horizontal">
        <h4>Energy Streams</h4>

        <div class="form-group">
          <div class="col-xs-12">
            <select
              name="selectedProviderUnitOperationId"
              id="selectedProviderUnitOperationId"
              formControlName="selectedProviderUnitOperationId"
              size="2"
              style="height: 200px"
              class="form-control">
              <option
                (click)="filterStreams()"
                *ngFor="let uo of availableProviderUnitOperations"
                value="{{ uo.id }}"
                (dblclick)="addEnergyStream()">
                {{ uo.name }} - Energy Flow
              </option>
            </select>

            <button class="btn btn-xs btn-success m-t-xs" (click)="addEnergyStream()">
              <i class="fa fa-plus-circle"></i>
            </button>
          </div>
        </div>

        <ng-container formArrayName="energyStreams">
          <ng-container *ngFor="let energyStreamGroup of getEnergyStreamsFormGroupsArray(); let i = index">
            <div class="row energy-stream-row">
              <h4>
                <a
                  data-toggle="collapse"
                  href="#energyStreamCollapse{{ i }}"
                  aria-expanded="false"
                  sfeCollapsePanelIcon>
                  <i class="fa fa-plus" aria-hidden="true"> </i>
                  {{ activeEnergyStreams[i].getFullName() }}
                </a>
              </h4>
              <div>
                <span class="inline pull-right p-t-5-x" style="margin-top: -30px">
                  <button
                    class="btn-remove btn btn-xs btn-danger"
                    (click)="removeEnergyStream(i)"
                    data-toggle="tooltip"
                    title="Remove Energy Stream">
                    <i class="fa fa-minus-circle"></i>
                  </button>
                </span>
              </div>
              <div id="energyStreamCollapse{{ i }}" class="collapse">
                <sob-energy-stream-form
                  [energyStream]="activeEnergyStreams[i]"
                  [energyStreamFormGroup]="energyStreamGroup">
                </sob-energy-stream-form>
              </div>
            </div>
            <hr />
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>

  <div role="tabpanel" class="tab-pane fade in" id="constraints">
    <div class="tab-content no-padding no-border">
      <div class="form-horizontal">
        <div class="form-group" formGroupName="heatFlow">
          <label class="control-label col-sm-4"> Energy Demand </label>
          <div class="col-sm-8" sobReactiveSimVarInput>
            <div class="row">
              <div class="col-xs-6">
                <sob-reactive-unit-select formControlName="unit" [quantity]="unitOperation.heatFlow.quantity">
                </sob-reactive-unit-select>
              </div>
              <div class="col-xs-6">
                <sob-reactive-variable-value-input formControlName="value" [valueMetaData]="unitOperation.heatFlow">
                </sob-reactive-variable-value-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div role="tabpanel" class="tab-pane fade in" id="fuelGasSinkImportComments">
    <div class="tab-content no-padding no-border">
      <sob-unit-operation-comments [unitOpId]="this.unitOperation.id"></sob-unit-operation-comments>
    </div>
  </div>
</div>
